import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { Box } from "@mui/material";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";

const stepperData = [
  "施設選択",
  "対象施設一覧/解除内容入力",
  "入力内容確認",
  "機構へ提出",
];

/**
 * フェイクテーブルのリスト
 */
const fakeTable: ITkFakeTableLineProps[] = [
  {
    keyword: "datePicker",
    requiredIcon: true,
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/01/01"),
    title: "解除年月日",
    type: "date",
    helpicon: true,
    helpText:
      "部分解除する年月日を入力してください。直接入力していただくか、「カレンダーボタン」にて日付を選択してください。なお、解除対象となる被共済職員（解除日に退職する職員も含む。）は退職手当金は支給されませんのでご注意ください。",
    setDefaultValue: null,
  },
  {
    keyword: "select",
    requiredIcon: true,
    selectPropsList: [],
    title: "解除対象となる職員の選択",
    type: "selectForm",
    helpicon: true,
    helpText: (
      <>
        <Box>部分解除する対象の職員を選択してください。</Box>
        <Box>
          ・「対象施設の被共済職員」は対象施設に解除日時点で在籍する全ての被共済職員が解除対象となります。
        </Box>
        <Box>
          ・「平成１８年４月１日以後加入した被共済職員」は対象施設（平成１８年３月３１日までに開設した老人関係施設）に解除日時点で在籍する被共済職員のうち平成１８年４月１日以後に加入した被共済職員（単位掛金額の３倍の掛金が必要な職員）が解除対象となります。
        </Box>
        <Box>
          ・「平成２８年４月１日以後加入した被共済職員」は対象施設（平成２８年３月３１日までに開設した障害関係施設）に解除日時点で在籍する被共済職員のうち平成２８年４月１日以後に加入した被共済職員（単位掛金額の３倍の掛金が必要な職員）が解除対象となります。
        </Box>
        <Box>
          ・「施設転換後の被共済職員」は①養護老人ホームから軽費老人ホーム（介護保険の指定を受けたもの）へ転換した施設または②軽費老人ホーム（介護保険の指定を受けていないもの）から軽費老人ホーム（介護保険指定を受けたもの）へ転換した施設に解除日時点で在籍する被共済職員のうち転換後に加入した被共済職員（単位掛金額の３倍の掛金が必要な職員）が解除の対象となります。
        </Box>
      </>
    ),
  },
  {
    keyword: "explanatoryText01",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050127_02,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "table",
    type: "node",
  },
  {
    keyword: "explanatoryText02",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050127_03,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "downloadLink",
    type: "node",
  },
  {
    keyword: "explanatoryText03",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050127_04,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "num",
    title: "部分解除の人数",
    type: "text",
    helpicon: true,
    helpText:
      "解除対象となる被共済職員の人数です。当該被共済職員は退職手当金は支給されません。",
  },
  {
    id: "1",
    keyword: "fileUpload",
    requiredIcon: true,
    setDefaultValue: [],
    title: "解除同意書の添付",
    type: "fileUpload",
    helpicon: true,
    helpText:
      "解除対象となる被共済職員全員の署名及び押印があることを確認し、アップロードしてください。",
  },
  {
    keyword: "cancelReason",
    requiredIcon: true,
    title: "解除理由",
    type: "textarea",
    helpicon: true,
    helpText:
      "解除の理由については具体的にご記入ください。例.他の共済制度に加入するため、掛金の負担が大きいため等",
  },
  {
    keyword: "explanatoryText05",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050127_05,
    explanatoryTextRule: "\\n",
  },
];

const schema = {
  datePicker: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  select: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  cancelReason: {
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "500"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
};

const headList = [
  {
    headTitle: (
      <>
        施設名称
        <TkHelpIcon helpMessage="部分解除を行う施設の名称です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        施設種類
        <TkHelpIcon helpMessage="部分解除を行う施設等の施設種類・サービス種類です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        従業状況確認
        <TkHelpIcon helpMessage="現在の職員の従業状況が確認できます。部分解除にあたって、部分解除を行う職員の従業状況を最新となるように更新してください。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        直近３ヶ月の退職者の証明書
        <TkHelpIcon helpMessage="契約解除日から遡って、３か月以内に退職者がいる場合は当該退職者について「雇用保険資格喪失証明書」等を登録してください。" />
      </>
    ),
  },
];

const facilityTypePattern = [
  {
    pattern: ["3102", "3101", "3109", "3106", "3107", "0802", "3105"],
    baseDate: "2006/04/01",
    options: [
      { label: "対象施設の被共済職員", value: "1" },
      { label: "平成18年4月1日以後加入した被共済職員", value: "2" },
    ],
    otherOptions: [{ label: "対象施設の被共済職員", value: "1" }],
  },
  {
    pattern: [
      "3201",
      "3215",
      "3218",
      "3202",
      "3203",
      "3206",
      "3207",
      "3205",
      "3208",
      "3209",
      "3210",
      "3211",
      "3212",
      "3204",
      "3214",
      "3213",
      "3217",
      "3216",
    ],
    baseDate: "2016/04/01",
    options: [
      { label: "対象施設の被共済職員", value: "1" },
      { label: "平成28年4月1日以後加入した被共済職員", value: "3" },
    ],
    otherOptions: [{ label: "対象施設の被共済職員", value: "1" }],
  },
];
const facilityTypePatternChangeOver = [
  { label: "対象施設の被共済職員", value: "1" },
  { label: "転換後の被共済職員", value: "4" },
];
const facilityTypePatternOther = [
  { label: "対象施設の被共済職員", value: "1" },
];

export {
  stepperData,
  fakeTable,
  schema,
  headList,
  facilityTypePattern,
  facilityTypePatternOther,
  facilityTypePatternChangeOver,
};
